import React from 'react';
import { PencilIcon } from 'lucide-react';
interface EditableCellProps {
  display: React.ReactNode;
  rawValue: number | null;
  label: string;
  editable: boolean;
  isEditing: boolean;
  onStart: () => void;
  onCommit: (raw: string) => void;
}
export function EditableCell({
  display,
  rawValue,
  label,
  editable,
  isEditing,
  onStart,
  onCommit
}: EditableCellProps) {
  if (!editable) return <span className="tabular-nums" data-id="element-78" data-mp="1oaykb7cveynp">{display}</span>;
  if (isEditing) {
    return <input autoFocus inputMode="decimal" aria-label={label} defaultValue={rawValue === null ? '' : String(rawValue)} onBlur={event => onCommit(event.target.value)} onKeyDown={event => {
      if (event.key === 'Enter') event.currentTarget.blur();
      if (event.key === 'Escape') onCommit(rawValue === null ? '' : String(rawValue));
    }} className="h-7 w-20 rounded border border-sf-blue bg-white px-2 text-right text-[13px] tabular-nums focus:outline-none focus:ring-1 focus:ring-sf-blue" data-id="element-79" data-mp="1t9i3x13zrycw" />;
  }
  return <button type="button" onClick={onStart} aria-label={`Edit ${label}`} className="group -mx-1 inline-flex w-[calc(100%+0.5rem)] items-center justify-end gap-1.5 rounded px-1 py-0.5 tabular-nums transition-colors duration-150 ease-out hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sf-blue" data-id="element-80" data-mp="3mgxqswtd56bc">
      <span data-id="element-81" data-mp="38ipmu4xwt4qo">{display}</span>
      <PencilIcon className="h-3 w-3 text-sf-weak opacity-40 transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100" aria-hidden="true" data-id="element-82" data-mp="38izhw6xta238" />
    </button>;
}